import React, { useState, useEffect } from 'react';
import { Table, Icon, DatePicker, Badge, Tooltip, Input, Button, Empty } from 'antd';
import DetailsModal from './auditDetailsModal';
import {
  SettingpageConatiner,
  DetailHeadingCover,
  Detailwrapper,
  SearchContainer,
} from '../GlobalVariablesPage/styles';
import { Container } from './styles';
import { getEmailRequestList } from '../../utils/services/emailAuditAPI';
import { withTranslation } from 'react-i18next';
import { EMAIL_AUDIT as trans } from './translationValues';

const NAMESPACE = ['EMAIL_AUDIT'];

const MailAudit = props => {
  const { t } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortedInfo, setSortedInfo] = useState(null);
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const [selectedReqID, setSelectedReqID] = useState(false);
  const [createdDates, setCreatedDates] = useState(null);
  const [updatedDates, setUpdatedDates] = useState(null);
  const [searchedID, setSearchedID] = useState(null);
  const { RangePicker } = DatePicker;
  const windowSize = window.innerWidth;

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      let payload = {
        pageNo: currentPage,
        limit: 10,
        channel: 'email',
      };
      if (filteredInfo) {
        if (filteredInfo?.transactionStatus && filteredInfo?.transactionStatus?.length === 1) {
          payload.result = filteredInfo?.transactionStatus[0];
        }
        if (filteredInfo?.status && filteredInfo?.status?.length !== 0) {
          payload.status = filteredInfo?.status;
        }
        if (filteredInfo?.environmentType && filteredInfo?.environmentType?.length === 1) {
          payload.environmentType = filteredInfo?.environmentType;
        }
      }
      if (createdDates) {
        if (createdDates[0] !== '' && createdDates[1] !== '') {
          payload.createdOnStartTime = createdDates[0];
          payload.createdOnEndTime = createdDates[1];
        }
      }
      if (updatedDates) {
        if (updatedDates[0] !== '' && updatedDates[1] !== '') {
          payload.updatedOnStartTime = updatedDates[0];
          payload.updatedOnEndTime = updatedDates[1];
        }
      }
      if (sortedInfo && sortedInfo?.order) {
        payload.sortBy =
          sortedInfo?.field === 'createdOn' ? 'createdTimestamp' : 'lastUpdatedTimestamp';
        payload.sortByOrder = sortedInfo?.order;
      }
      if (searchedID) {
        payload.transactionId = searchedID;
      }
      let response = await getEmailRequestList(payload);
      if (response) {
        if (response.data) {
          setTableData(response);
        }
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line
  }, [currentPage, filteredInfo, createdDates, updatedDates, sortedInfo, searchedID]);
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <SearchContainer>
        <Input
          className="searchInput"
          placeholder={t(trans.SEARCH_REQUEST_ID_PLACEHOLDER.key, trans.SEARCH_REQUEST_ID_PLACEHOLDER.value)}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => setSearchedID(selectedKeys)}
          style={{ minWidth: 188, width: '100%', marginBottom: 8, display: 'block' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', columnGap: '4px' }}>
          <Button
            type="primary"
            onClick={() => setSearchedID(selectedKeys)}
            icon="search"
            style={{ minWidth: '80px', width: 'fit-content' }}
          >
            {t(trans.SEARCH_BUTTON.key, trans.SEARCH_BUTTON.value)}
          </Button>
          <Button onClick={() => handleReset(clearFilters)} style={{ minWidth: '80px', width: 'fit-content' }}>
            {t(trans.CLEAR_BUTTON.key, trans.CLEAR_BUTTON.value)}
          </Button>
        </div>
      </SearchContainer>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  });

  const handleReset = clearFilters => {
    clearFilters();
    setSearchedID(null);
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    setFilteredInfo(filters);
  };

  const onCreatedDateChange = (date, dateString) => {
    setCreatedDates(dateString);
  };

  const onUpdatedDateChange = (date, dateString) => {
    setUpdatedDates(dateString);
  };

  const showDetails = async record => {
    setIsDetailsVisible(true);
    setSelectedReqID(record?.transactionId);
  };

  const columns = [
    {
      title: t(trans.REQUEST_ID_COLUMN.key, trans.REQUEST_ID_COLUMN.value),
      dataIndex: 'transactionId',
      key: 'transactionId',
      ellipsis: true,
      width: '22%',
      ...getColumnSearchProps('transactionId'),
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            width: windowSize < 1441 ? '100px' : '130px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          onClick={e => e.stopPropagation()}
        >
          <p>{t(trans.CREATED_ON_COLUMN.key, trans.CREATED_ON_COLUMN.value)}</p>
          <RangePicker
            showTime={{ format: 'HH:mm:ss' }}
            format={'YYYY-MM-DD HH:mm:ss'}
            placeholder={[t(trans.RANGE_PICKER_START_PLACEHOLDER.key, trans.RANGE_PICKER_START_PLACEHOLDER.value), t(trans.RANGE_PICKER_END_PLACEHOLDER.key, trans.RANGE_PICKER_END_PLACEHOLDER.value)]}
            onChange={onCreatedDateChange}
            onClick={e => e.stopPropagation()}
            style={{width:'0'}}
          />
        </div>
      ),
      dataIndex: 'createdOn',
      key: 'createdOn',
      sorter: true,
      ellipsis: true,
      width: '13%',
    },
    {
      title: t(trans.REQUEST_STATUS_COLUMN.key, trans.REQUEST_STATUS_COLUMN.value),
      dataIndex: 'transactionStatus',
      key: 'transactionStatus',
      filters: [
        { text: t(trans.SUCCESS_STATUS.key, trans.SUCCESS_STATUS.value), value: 'Success' },
        { text: t(trans.FAILURE_STATUS.key, trans.FAILURE_STATUS.value), value: 'Failure' },
      ],
      filteredValue: filteredInfo?.transactionStatus || null,
      onFilter: () => {
        return true;
      },
      ellipsis: true,
      render: text => (
        <>
          <Badge status={text === 'Success' ? 'success' : 'error'} />
          {text}
        </>
      ),
      width: '15%',
    },
    {
      title: t(trans.STATUS_COLUMN.key, trans.STATUS_COLUMN.value),
      dataIndex: 'status',
      key: 'status',
      filters: [
        { text: t(trans.RECEIVED_STATUS_FILTER.key, trans.RECEIVED_STATUS_FILTER.value), value: 'Received' },
        { text: t(trans.INQUEUE_STATUS_FILTER.key, trans.INQUEUE_STATUS_FILTER.value), value: 'Inqueue' },
        { text: t(trans.PROCESSING_STATUS_FILTER.key, trans.PROCESSING_STATUS_FILTER.value), value: 'Processing' },
        { text: t(trans.FAILURE_STATUS_FILTER.key, trans.FAILURE_STATUS_FILTER.value), value: 'Failure' },
        { text: t(trans.RETRYING_STATUS_FILTER.key, trans.RETRYING_STATUS_FILTER.value), value: 'Retrying' },
        { text: t(trans.FILE_ATTACHED_STATUS_FILTER.key, trans.FILE_ATTACHED_STATUS_FILTER.value), value: 'File Attached' },
        { text: t(trans.SENT_STATUS_FILTER.key, trans.SENT_STATUS_FILTER.value), value: 'Sent' },
        { text: t(trans.SHARED_WEB_HOOK_STATUS_FILTER.key, trans.SHARED_WEB_HOOK_STATUS_FILTER.value), value: 'Shared Web Hook Response' },
        { text: t(trans.FAILURE_SHARED_WEB_HOOK_STATUS_FILTER.key, trans.FAILURE_SHARED_WEB_HOOK_STATUS_FILTER.value), value: 'Failure In Share Web Hook Response' },
      ],
      filteredValue: filteredInfo?.status || null,
      onFilter: () => {
        return true;
      },
      ellipsis: true,
      width: '7%'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            width: windowSize < 1441 ? '100px' : '130px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          onClick={e => e.stopPropagation()}
        >
          <p>{t(trans.UPDATED_ON_COLUMN.key, trans.UPDATED_ON_COLUMN.value)}</p>
          <RangePicker
            showTime={{ format: 'HH:mm:ss' }}
            format={'YYYY-MM-DD HH:mm:ss'}
            placeholder={[t(trans.RANGE_PICKER_START_PLACEHOLDER.key, trans.RANGE_PICKER_START_PLACEHOLDER.value), t(trans.RANGE_PICKER_END_PLACEHOLDER.key, trans.RANGE_PICKER_END_PLACEHOLDER.value)]}
            onChange={onUpdatedDateChange}
            onClick={e => e.stopPropagation()}
            style={{width:'0'}}
          />
        </div>
      ),
      dataIndex: 'updatedOn',
      key: 'updatedOn',
      sorter: true,
      ellipsis: true,
      width: '13%',
    },
    {
      title: t(trans.TEMPLATE_NAME_COLUMN.key, trans.TEMPLATE_NAME_COLUMN.value),
      dataIndex: 'templateId',
      key: 'templateId',
      render: (text, record) => record.templateName + '-' + record.templateId,
      ellipsis: true,
    },
    {
      title: t(trans.REQUEST_TYPE_COLUMN.key, trans.REQUEST_TYPE_COLUMN.value),
      dataIndex: 'environmentType',
      key: 'environmentType',
      render: text => text,
      filters: [
        { text: t(trans.SANDBOX_FILTER.key, trans.SANDBOX_FILTER.value), value: 'sandbox' },
        { text: t(trans.LIVE_FILTER.key, trans.LIVE_FILTER.value), value: 'live' },
      ],
      filteredValue: filteredInfo?.environmentType || null,
      onFilter: (value, record) => record?.environmentType.includes(value),
      ellipsis: true,
      width: '12%',
    },
    {
      title: t(trans.ACTION_COLUMN.key, trans.ACTION_COLUMN.value),
      key: 'action',
      render: (text, record) => (
        <Tooltip title={t(trans.VIEW_DETAILS_TOOLTIP.key, trans.VIEW_DETAILS_TOOLTIP.value)}>
          <Icon type="eye" onClick={() => showDetails(record)} />
        </Tooltip>
      ),
      width: '7%',
    },
  ];

  return (
    <React.Fragment>
      <Container>
        <SettingpageConatiner isEmailAudit={true}>
          <Detailwrapper>
            <DetailHeadingCover isEmailAudit={true}>
              <div>
                <h5>{t(trans.EMAIL_AUDIT_TITLE.key, trans.EMAIL_AUDIT_TITLE.value)}</h5>
              </div>
            </DetailHeadingCover>
            <Table
              columns={columns}
              dataSource={tableData?.data}
              loading={isLoading}
              rowKey={record => record.rgid}
              onChange={handleChange}
              scroll={{ y: windowSize < 1441 && '30vw' }}
              pagination={{
                current: currentPage,
                defaultPageSize: 10,
                hideOnSinglePage: true,
                total: tableData?.dataCount,
                onChange: e => setCurrentPage(e),
              }}
            locale={{
              emptyText: <Empty description={t(trans.EMPTY_TABLE_DESCRIPTION.key, trans.EMPTY_TABLE_DESCRIPTION.value)} />,
              filterConfirm: t(trans.FILTER_CONFIRM_BUTTON.key, trans.FILTER_CONFIRM_BUTTON.value),
              filterReset: t(trans.FILTER_RESET_BUTTON.key, trans.FILTER_RESET_BUTTON.value),
            }}
            showSorterTooltip={false}
            />
          </Detailwrapper>
        </SettingpageConatiner>
      </Container>
      <DetailsModal
        isVisible={isDetailsVisible}
        selectedID={selectedReqID}
        onCancel={() => {
          setIsDetailsVisible(false);
          setSelectedReqID(null);
        }}
      />
    </React.Fragment>
  );
};

export default withTranslation(NAMESPACE)(MailAudit);
